import { useContractInputStore } from './useContractInputStore';
import { useSkipFeaturesStore } from './useSkipFeaturesStore';
import { useTabInfoStore } from './useTabInfoStore';

export { useSkipFeaturesStore, useContractInputStore, useTabInfoStore };

const contractInfoStore = { useSkipFeaturesStore, useContractInputStore, useTabInfoStore };

export default contractInfoStore;
